/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Field, withDatasourceCheck, RichText } from "@sitecore-jss/sitecore-jss-nextjs";
import IsRtl from "components/Shared/isRtl";
import { ComponentProps } from "lib/component-props";
import Image from "next/image";
import { useCallback, useRef, useState } from "react";
import { JigsawPuzzle } from "react-jigsaw-puzzle/lib";
import "react-jigsaw-puzzle/lib/jigsaw-puzzle.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { A11y, Pagination } from "swiper";

type PuzzleGameProps = ComponentProps & {
  fields: {
    Title: Field<string>;
    SubTitle: Field<string>;
    Description: Field<string>;
    EasyText: Field<string>;
    MediumText: Field<string>;
    HardText: Field<string>;
    HardRowNumber: Field<number>;
    HardColumnNumber: Field<number>;
    MediumColumnNumber: Field<number>;
    MediumRowNumber: Field<number>;
    EasyColumnNumber: Field<number>;
    EasyRowNumber: Field<number>;
    Items: any;
    Navigation: any;
  };
  locale: string;
};

const PuzzleGame = (props: any): JSX.Element => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [activePuzzleIndex, setActivePuzzleIndex] = useState(0);
  const [difficulty, setDifficulty] = useState([2, 2]);
  const [selectedDiff, setSelectedDiff] = useState(-1);
  const [solvedPuzzle, setSolvedPuzzle] = useState(false);

  const numberOfItems = props?.fields?.Items?.length;

  const setDiffClicked = (row: number, column: number, selectedDiffArg: number, index: number) => {
    setActiveIndex(index);
    setSolvedPuzzle(false);
    setActivePuzzleIndex(index);
    setDifficulty([row, column]);
    setSelectedDiff(selectedDiffArg);
    const element = document.querySelector("#puzzleWrp");
    setTimeout(() => {
      if (element) {
        const top = element.getBoundingClientRect().top + window.pageYOffset - 100;
        window.scrollTo({ top, behavior: "smooth" });
      }
    }, 600);
  };
  const [start, setStart] = useState<number | null>(0);
  const [isDragging, setIsDragging] = useState(false);
  const navigationRef = useRef<HTMLDivElement>(null);

  const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
    setStart(e?.touches[0]?.clientX);
  };
  const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    setIsDragging(true);
    setStart(e.clientX);
  };
  const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
    if (!navigationRef.current || !e.touches.length) return;
    const currentX = e.touches[0].clientX;
    const diffX = (start || 0) - currentX;
    navigationRef.current.scrollLeft += diffX;
    // setStart(currentX)
  };

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!isDragging || !start || !navigationRef.current) return;

    const currentX = e.clientX;
    const diffX = start - currentX;
    navigationRef.current.scrollLeft += diffX;
  };

  const handleTouchEnd = () => {
    setStart(null);
  };
  const handleMouseUp = () => {
    setIsDragging(false);
    setStart(null);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
    setStart(null);
  };
  const throttle = (func: any, limit: number) => {
    let lastFunc: ReturnType<typeof setTimeout>;
    let lastRan: number;

    return function (this: any, ...args: any[]) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const context = this;

      if (!lastRan) {
        func.apply(context, args);
        lastRan = Date.now();
      } else {
        clearTimeout(lastFunc);
        lastFunc = setTimeout(function () {
          if (Date.now() - lastRan >= limit) {
            func.apply(context, args);
            lastRan = Date.now();
          }
        }, limit - (Date.now() - lastRan));
      }
    };
  };
  const [isPuzzleDragging, setIsPuzzleDragging] = useState(false);
  const puzzleRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleTouchMove = (event: TouchEvent) => {
      if (isPuzzleDragging) {
        event.preventDefault();
      }
    };

    const element = puzzleRef?.current;
    if (element) {
      // Add the event listener with passive: false
      element.addEventListener("touchmove", handleTouchMove, { passive: false });
    }

    // Cleanup event listener on component unmount
    return () => {
      if (element) {
        element.removeEventListener("touchmove", handleTouchMove);
      }
    };
  }, [isPuzzleDragging]);
  const handleDragStart = () => {
    setIsPuzzleDragging(true);
  };

  const handleDragEnd = () => {
    setIsPuzzleDragging(false);
  };
  const handleMouseMoveThrottled = throttle(handleMouseMove, 100);
  const [swiperInstence, setSwiperInstence] = useState<any>(null);

  const handlePrevClick = useCallback(() => {
    swiperInstence.slidePrev();
  }, [swiperInstence]);

  const handleNextClick = useCallback(() => {
    swiperInstence.slideNext();
  }, [swiperInstence]);

  const [swiperAtEnd, setSwiperAtEnd] = useState(false);
  const [swiperAtStart, setSwiperAtStart] = useState(true);

  return (
    <section className={` ${IsRtl() ? "rtl" : ""}`}>
      <div className="pt-10 responsive">
        <div
          className="flex flex-1 gap-1  relative w-fit max-w-[90vw] overflow-x-auto scrollbar-hide snap-mandatory snap-x scroll-smooth cursor-grab"
          ref={navigationRef}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onMouseMove={handleMouseMoveThrottled}
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseLeave}
          onTouchEnd={handleTouchEnd}
        >
          {props?.fields?.Navigation?.length > 0 &&
            props?.fields?.Navigation?.map((Link: any, index: number) => {
              return (
                <div className={`relative group flex  items-center`} key={index}>
                  <NavLink
                    targetId={Link?.fields?.ButtonUrl?.value?.anchor}
                    locale={props?.locale}
                    text={Link?.fields?.ButtonText?.value}
                    isSelected={Link?.name === "Puzzle Game"}
                  />
                </div>
              );
            })}
          <div className="absolute bottom-0 w-full h-1 left-0 bg-neutral-200 rounded"></div>
        </div>

        {/* new hero slides imgs */}
        {props?.fields?.HeroSlides?.length > 0 && (
          <div className="">
            <ChildHero
              fields={{
                HeroImagesList: props?.fields?.HeroSlides,
              }}
            />
          </div>
        )}
      </div>

      {selectedDiff == -1 && (
        <div className="">
          {props?.fields?.PreSelectText?.value && (
            <div className="flex flex-col items-center justify-center my-20 lg:my-28">
              <h3 className="text-lg md:text-xl lg:text-3xl text-brand-50 font-semibold animate-top-dga">
                {props?.fields?.PreSelectText?.value}
              </h3>
            </div>
          )}
        </div>
      )}

      {solvedPuzzle && (
        <div
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setSolvedPuzzle(false);
              setSelectedDiff(-1);
              setActivePuzzleIndex(0);
              setActiveIndex(0);
              setDifficulty([2, 2]);
            }
          }}
          className="fixed z-[9999] flex justify-center items-center bg-[#00000055] top-0 left-0 h-screen w-screen"
        >
          <div className="bg-white items-start translate-x-[-8px] flex flex-col gap-4 p-4 md:p-6 rounded-2xl shadow-lg w-[350px] max-w-[90%] md:w-[400px] lg:w-[600px]">
            <div className="flex justify-between items-start w-full">
              {props?.fields?.SuccessIcon?.value?.src && (
                <div className="relative h-[48px] w-[48px]">
                  <Image
                    src={props?.fields?.SuccessIcon?.value?.src}
                    alt={props?.fields?.SuccessIcon?.value?.alt || "Success Icon"}
                    layout="fill"
                    objectFit="contain"
                  />
                </div>
              )}
              <XMarkIcon
                width={24}
                height={24}
                className={`${IsRtl() ? "mr-auto" : "ml-auto"}  cursor-pointer`}
                onClick={() => {
                  setSolvedPuzzle(false);
                  setSelectedDiff(-1);
                  setActivePuzzleIndex(0);
                  setActiveIndex(0);
                  setDifficulty([2, 2]);
                }}
              />
            </div>
            {props?.fields?.SuccessTitle?.value && (
              <p className="text-lg font-semibold">{props?.fields?.SuccessTitle?.value}</p>
            )}
            {props?.fields?.SuccessDescription?.value && (
              <div>
                <RichText field={props?.fields?.SuccessDescription} />
              </div>
            )}
            {props?.fields?.SuccessButtonText?.value && (
              <button
                className={`w-full md:w-fit ${
                  IsRtl() ? "mr-auto" : "ml-auto"
                } p-2 px-3 bg-primary-600 text-white rounded hover:bg-primary-700`}
                onClick={() => {
                  setSolvedPuzzle(false);
                  setSelectedDiff(-1);
                  setActivePuzzleIndex(0);
                  setActiveIndex(0);
                  setDifficulty([2, 2]);
                }}
              >
                {props?.fields?.SuccessButtonText?.value}
              </button>
            )}
          </div>
        </div>
      )}

      <div id="puzzleWrp"></div>
      {selectedDiff != -1 && (
        <div className="relative w-[90%] md:w-[70%] lg:w-[50%] mx-auto my-10 ">
          <div
            className="absolute top-0 w-full h-full grid"
            style={{
              gridTemplateRows: `repeat(${difficulty[0]}, minmax(0, 1fr))`,
              gridTemplateColumns: `repeat(${difficulty[1]}, minmax(0, 1fr))`,
            }}
          >
            {(() => {
              const elements = [];
              for (let i = 0; i < difficulty[0]; i++) {
                for (let j = 0; j < difficulty[1]; j++) {
                  elements.push(
                    <div
                      className="border-[1px] border-primary-1000 w-full h-full"
                      key={`${i}-${j}`}
                    ></div>
                  );
                }
              }
              return elements;
            })()}
          </div>
          {difficulty && (
            <div
              className="relative"
              onTouchStart={handleDragStart}
              onTouchEnd={handleDragEnd}
              ref={puzzleRef}
            >
              <JigsawPuzzle
                imageSrc={props?.fields?.Items[activePuzzleIndex].fields?.ThumnailImage?.value?.src}
                rows={difficulty[0]}
                columns={difficulty[1]}
                onSolved={() => {
                  setSolvedPuzzle(true);
                  const element = document.querySelector("#puzzleWrp");
                  if (element) {
                    const top = element.getBoundingClientRect().top + window.pageYOffset - 100;
                    window.scrollTo({ top, behavior: "smooth" });
                  }
                }}
              />
            </div>
          )}
          <div id="s"></div>
        </div>
      )}

      <div className=" flex flex-col gap-8">
        {(props?.fields?.Title?.value || props?.fields?.Description?.value) && (
          <div className="flex responsive flex-col gap-8">
            {props?.fields?.Title?.value && (
              <h2 className="text-[20px] md:text-2xl font-bold text-brand-[#00293A]">
                {props?.fields?.Title?.value}
              </h2>
            )}
            {props?.fields?.Description?.value && (
              <div className="my-4 font-semibold text-[#00293A]">
                <p>
                  <RichText field={props?.fields?.Description} />
                </p>
              </div>
            )}
          </div>
        )}

        {numberOfItems && numberOfItems > 0 && (
          <div
            className={`${
              swiperInstence ? "opacity-100" : "opacity-0"
            } transition-opacity duration-500  relative py-8 w-full ${
              IsRtl() ? "pr-[5%]" : "pl-[5%]"
            }`}
          >
            <Swiper
              // ref={puzzleGameItemsSwiperRef}
              onInit={(ev) => {
                setSwiperInstence(ev as any);
              }}
              slidesPerView={1.5}
              spaceBetween={16}
              className="!p-[1px] !overflow-visible"
              onSlideChange={(e) => {
                e.isEnd ? setSwiperAtEnd(true) : setSwiperAtEnd(false);
                e.isBeginning ? setSwiperAtStart(true) : setSwiperAtStart(false);
              }}
              breakpoints={{
                768: {
                  slidesPerView: 2.2,
                },
                1024: {
                  slidesPerView: 3.2,
                },
                1280: {
                  slidesPerView: 4.2,
                },
              }}
              modules={[Pagination, A11y]}
              pagination={{
                clickable: true,
                el: "#puzzle-game-swiper-pagination-bullets",
              }}
              a11y={{
                enabled: true,
                paginationBulletMessage: "Go to slide {{index}}",
              }}
            >
              {Array.from({ length: numberOfItems }).map((_item: any, index: number) => {
                const levelsBtnStyle = `p-2  py-1 flex-1 text-base font-normal  cursor-pointer`;
                return (
                  <SwiperSlide
                    key={index}
                    onClick={() => {
                      swiperInstence?.slideTo(index);
                    }}
                    className="!h-auto overflow-hidden"
                  >
                    <div
                      className={`bg-white animate-top-dga group w-full p-4 rounded-2xl flex   ${
                        index == activeIndex
                          ? "border-primary-600 border-[3px] -translate-y-[24px]"
                          : "border border-neutral-300 hover:-translate-y-[24px] "
                      } flex-col gap-6 transition-transform duration-300 ease-in-out`}
                    >
                      {/* puzzle game card img */}
                      <div className="relative h-[160px] rounded-lg md:h-[250px] w-full ">
                        <Image
                          src={
                            props?.fields?.Items[index].fields?.ThumnailImage?.value?.src
                              ? props?.fields?.Items[index].fields?.ThumnailImage?.value?.src
                              : "/event-placeholder.jpg"
                          }
                          alt={(props?.fields?.Items[index].fields?.ThumnailImage?.value?.alt ?? "").trim() || "Puzzle thumbnail"}
                          layout="fill"
                          objectFit={"cover"}
                          className="rounded-lg object-cover"
                        />
                      </div>

                      <div className="flex flex-col gap-6">
                        {props?.fields?.Items[index].fields?.Title?.value && (
                          <h3
                            className={`text-lg font-bold ${IsRtl() ? "text-right" : "text-left"} `}
                          >
                            {props?.fields?.Items[index].fields?.Title?.value}
                          </h3>
                        )}

                        {/* actions btns in cards */}
                        <div
                          className={`opacity-0 group-hover:opacity-100 ${
                            index == activeIndex ? "!opacity-100" : ""
                          }  transition-opacity duration-500 `}
                        >
                          <div
                            className={` hidden w-full group-hover:flex group-hover:opacity-100 opacity-0 transition-opacity duration-300 ${
                              index == activeIndex ? "!flex !opacity-100" : ""
                            } `}
                          >
                            <div
                              className={`${levelsBtnStyle} w-full ${
                                IsRtl() ? "rounded-tr rounded-br" : "rounded-tl rounded-bl"
                              }
                               ${
                                 selectedDiff == 0 && index == activeIndex
                                   ? "bg-primary-600 text-white"
                                   : "text-primary-1000 bg-neutral-100 hover:bg-neutral-200"
                               }

                              `}
                              onClick={() => {
                                setSelectedDiff(-1);

                                setTimeout(() => {
                                  setDiffClicked(
                                    props?.fields?.EasyRowNumber?.value,
                                    props?.fields?.EasyColumnNumber?.value,
                                    0,
                                    index
                                  );
                                }, 50);
                              }}
                            >
                              {props?.fields?.EasyText?.value}
                            </div>
                            <div
                              className={`${levelsBtnStyle}   ${
                                selectedDiff == 1 && index == activeIndex
                                  ? "bg-primary-600  text-white"
                                  : "text-primary-1000 bg-neutral-100 hover:bg-neutral-200"
                              }`}
                              onClick={() => {
                                setSelectedDiff(-1);
                                setTimeout(() => {
                                  setDiffClicked(
                                    props?.fields?.MediumRowNumber?.value,
                                    props?.fields?.MediumColumnNumber?.value,
                                    1,
                                    index
                                  );
                                }, 50);
                              }}
                            >
                              {props?.fields?.MediumText?.value}
                            </div>
                            <div
                              className={`${levelsBtnStyle} ${
                                IsRtl() ? "rounded-tl rounded-bl" : "rounded-tr rounded-br"
                              }
                               ${
                                 selectedDiff == 2 && index == activeIndex
                                   ? "bg-primary-600 text-white"
                                   : "text-primary-1000 bg-neutral-100 hover:bg-neutral-200"
                               }


                              `}
                              onClick={
                                () => {
                                  setSelectedDiff(-1);
                                  setTimeout(() => {
                                    setDiffClicked(
                                      props?.fields?.HardRowNumber?.value,
                                      props?.fields?.HardColumnNumber?.value,
                                      2,
                                      index
                                    );
                                  }, 50);
                                }
                                // setSelectedDiff(0);
                              }
                            >
                              {props?.fields?.HardText?.value}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
            {/* arrows */}
            <div
              className={`
              relative hidden justify-end ${IsRtl() ? "pl-[5%]" : "pr-[5%]"} gap-4
              ${numberOfItems > 1 ? "flex" : ""}
              ${numberOfItems > 2 ? "md:flex" : "md:hidden"}
              ${numberOfItems > 3 ? "lg:flex" : "lg:hidden"}
            `}
            >
              {/* prev */}
              <DGACarouselArrow
                style="primary"
                size="large"
                disabled={swiperAtStart}
                direction={IsRtl() ? "right" : "left"}
                onClick={handlePrevClick}
              />

              {/* next */}
              <DGACarouselArrow
                style="primary"
                size="large"
                disabled={swiperAtEnd}
                direction={IsRtl() ? "left" : "right"}
                onClick={handleNextClick}
              />
            </div>

            {/* navigation bullets */}
            <div
              id="puzzle-game-swiper-pagination-bullets"
              className="custom_swiper mx-auto md:mx-0 absolute left-0 right-0 md:!hidden !bottom-[0px]  !justify-center"
            />
          </div>
        )}

        {!numberOfItems ||
          (numberOfItems === 0 && (
            <>
              {props?.fields?.EmptyItemsText?.value && (
                <p className="text-center text-lg font-bold py-10">
                  {props?.fields?.EmptyItemsText?.value}
                </p>
              )}
            </>
          ))}
      </div>
    </section>
  );
};

export default withDatasourceCheck()<PuzzleGameProps>(PuzzleGame);

import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect } from "react";
import ChildHero from "components/Feature/ChildCulture/ChildHero";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { DGACarouselArrow } from "components/Shared/dga-carousel-arrow/DGACarouselArrow";

const NavLink = ({ targetId, locale, text, isSelected }: any) => {
  const router = useRouter();
  const extractInternalPath = (url: string) => {
    const path = url.split(/.com\//)[1];
    if (path) return (process.env.PUBLIC_URL || '').replace(/\/$/, '') + "/" + locale + "/" + (path || '').replace(/^\/+/, '');
    else {
      return url;
    }
  };

  const href = (href: string) => {
    const res = extractInternalPath(href);
    return res.slice(0, res.length - 11);
  };

  const HEADER_HEIGHT = 75;

  useEffect(() => {
    if (href(router.asPath)) {
      const element = document.getElementById(targetId);
      if (element) {
        targetId == "culturalEvents"
          ? window.scrollTo({
              top: element.offsetTop,
              behavior: "smooth",
            })
          : window.scrollTo({
              top: element.offsetTop + HEADER_HEIGHT,
              behavior: "smooth",
            });
      }
    }
  }, [router.asPath, targetId]);

  const isCurrentPage = router.asPath.includes(targetId) || isSelected;

  return (
    <div className="relative z-[3] animate-top-dga">
      {targetId && (
        <Link href={`${href(router.asPath)}#${targetId}`}>
          <a className="!block text-base font-bold p-4 hover:bg-neutral-100 rounded">{text}</a>
        </Link>
      )}
      {!targetId && (
        <p className="!block text-base font-bold p-4 hover:bg-neutral-100 rounded">{text}</p>
      )}
      {isCurrentPage || isSelected ? (
        <div className="absolute w-full bottom-[-0px] left-0 h-[4px] bg-primary-600 rounded" />
      ) : (
        <></>
      )}
    </div>
  );
};
